import React, { useEffect } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { getConfig } from '../stateAtoms/checkout';
import styles from './Checkout.module.scss';

function Checkout({ id, country }) {
  const { state, contents } = useRecoilValueLoadable(getConfig);

  useEffect(() => {
    if (state === 'hasValue') {
      window.$ResursCheckout.create({
        paymentSessionId: id,
        baseUrl: contents.checkoutUrl[country],
        context: 'self-checkout'
      });
    }
  }, [state, contents, id, country]);
  return (
    <div className="row">
      {state === 'hasValue' && <div className={styles.CheckoutContainer} id="rco-container"></div>}
    </div>
  );
}

export default Checkout;
